import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  getChiTietHopDongSuccess,
  getChiTietHopDongFailure,
  getLichSuHopDongSuccess,
  getLichSuHopDongFailure,
  getLichSuVayThemTraBotGocSuccess,
  getLichSuVayThemTraBotGocFailure,
  getListTaiSanCamCoSuccess,
  getListTaiSanCamCoFailure,
  getLichSuNoPhaiThuSuccess,
  getLichSuNoPhaiThuFailure,
  getListGhiChuSuccess,
  getListGhiChuFailure,
} from "actions/ChiTietHopDong";
import ChiTietHopDongApi from "service/chiTietHopDongApi";
import { pushNotification } from "utils/notifications";
import {
  GET_CHITIET_HOPDONG,
  GET_LICH_SU_HOP_DONG,
  GET_LICH_SU_VT_TB,
  GET_LIST_TAI_SAN_CAM_CO,
  GET_LIST_GHI_CHU,
  GET_LICH_SU_NO_PHAI_THU,
} from "actions/ChiTietHopDong/actionTypes";

function* getChiTietHopDong(action) {
  try {
    const response = yield call(
      ChiTietHopDongApi.getChiTietHopDong,
      action.dataSearch
    );
    if (response.ok) {
      yield put(getChiTietHopDongSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getChiTietHopDongFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getChiTietHopDongFailure());
  }
}

function* getLichSuHopDong(action) {
  try {
    const response = yield call(
      ChiTietHopDongApi.getLichSuHopDong,
      action.dataSearch
    );
    if (response.ok) {
      yield put(getLichSuHopDongSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getLichSuHopDongFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getLichSuHopDongFailure());
  }
}
function* getLichSuVayThemTraBotGoc(action) {
  try {
    const response = yield call(
      ChiTietHopDongApi.getLichSuVayThemTraBotGoc,
      action.dataSearch
    );
    if (response.ok) {
      yield put(getLichSuVayThemTraBotGocSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getLichSuVayThemTraBotGocFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getLichSuVayThemTraBotGocFailure());
  }
}
function* getListTaiSanCamCo(action) {
  try {
    const response = yield call(
      ChiTietHopDongApi.getListTaiSanCamCo,
      action.dataSearch
    );
    if (response.ok) {
      yield put(getListTaiSanCamCoSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListTaiSanCamCoFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListTaiSanCamCoFailure());
  }
}
function* getLichSuNoPhaiThu(action) {
  try {
    const response = yield call(
      ChiTietHopDongApi.getLichSuNoPhaiThu,
      action.dataSearch
    );
    if (response.ok) {
      yield put(getLichSuNoPhaiThuSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getLichSuNoPhaiThuFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getLichSuNoPhaiThuFailure());
  }
}

function* getListGhiChu(action) {
  try {
    const response = yield call(
      ChiTietHopDongApi.getListGhiChu,
      action.dataSearch
    );
    if (response.ok) {
      yield put(getListGhiChuSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListGhiChuFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListGhiChuFailure());
  }
}
function* watchGetRequest() {
  yield takeLatest(GET_LIST_GHI_CHU, getListGhiChu);
  yield takeLatest(GET_LICH_SU_NO_PHAI_THU, getLichSuNoPhaiThu);
  yield takeLatest(GET_LIST_TAI_SAN_CAM_CO, getListTaiSanCamCo);
  yield takeLatest(GET_CHITIET_HOPDONG, getChiTietHopDong);
  yield takeLatest(GET_LICH_SU_HOP_DONG, getLichSuHopDong);
  yield takeLatest(GET_LICH_SU_VT_TB, getLichSuVayThemTraBotGoc);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
